    <div class="loa-page">
      <div class="p-3 p-lg-4 loa-shell">
        <div class="d-flex flex-column flex-xl-row justify-content-between gap-3 align-items-xl-center">
          <div class="d-flex align-items-center gap-3">
            <span class="title-badge">
              <lucide-icon [img]="FileTextIcon" [size]="20"></lucide-icon>
            </span>
            <h1 class="page-title-lite">LOA Management</h1>
          </div>
          <div class="d-flex gap-2 flex-wrap justify-content-xl-end align-items-center">
            @if (!isVendorUser()) {
              <button class="btn btn-sm create-btn buy" type="button" (click)="createLoa('Buy')">
                <lucide-icon [img]="ShoppingCartIcon" [size]="14"></lucide-icon><span class="ms-2">CREATE BUY LOI</span>
              </button>
              <button class="btn btn-sm create-btn sell" type="button" (click)="createLoa('Sell')">
                <lucide-icon [img]="UserIcon" [size]="14"></lucide-icon><span class="ms-2">CREATE SELL LOI</span>
              </button>
              <button class="btn btn-sm create-btn banking" type="button" (click)="createLoa('Banking')">
                <lucide-icon [img]="RefreshCwIcon" [size]="14"></lucide-icon><span class="ms-2">CREATE BANKING LOI</span>
              </button>
            }
          </div>
        </div>

        <div class="row g-3 mt-1">
          @for (tile of summaryTiles(); track tile.label) {
            <div class="col-12 col-md-6 col-xl">
              <div class="summary-card h-100 clickable" (click)="applySummaryTile(tile.label)">
                <div class="summary-card-header">
                  <div class="summary-label">{{ tile.label }}</div>
                  <div class="summary-value">{{ tile.count }}</div>
                </div>
                <div class="summary-track">
                  @if (tile.count === 0) {
                    <div class="summary-segment" style="width:100%; background:#e4e9f2"></div>
                  } @else {
                    @if (tile.sell > 0) {
                      <div class="summary-segment sell clickable" [style.width.%]="segmentWidth(tile.sell, tile.count)" (click)="applySummaryCategory($event, tile.label, 'Sell')">
                        {{ tile.sell }}
                      </div>
                    }
                    @if (tile.buy > 0) {
                      <div class="summary-segment buy clickable" [style.width.%]="segmentWidth(tile.buy, tile.count)" (click)="applySummaryCategory($event, tile.label, 'Buy')">
                        {{ tile.buy }}
                      </div>
                    }
                    @if (tile.banking > 0) {
                      <div class="summary-segment banking clickable" [style.width.%]="segmentWidth(tile.banking, tile.count)" (click)="applySummaryCategory($event, tile.label, 'Banking')">
                        {{ tile.banking }}
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="panel-card p-3 p-lg-4">
        <div class="toolbar-row mb-3">
          <div class="quick-group">
            <button class="btn quick-btn" type="button" [class.active]="categoryMode() === 'Buy'" (click)="setCategoryMode('Buy')">
              <lucide-icon [img]="ShoppingCartIcon" [size]="15"></lucide-icon><span class="ms-2">BUY LOA</span>
            </button>
            <button class="btn quick-btn" type="button" [class.active]="categoryMode() === 'Sell'" (click)="setCategoryMode('Sell')">
              <lucide-icon [img]="UserIcon" [size]="15"></lucide-icon><span class="ms-2">SELL LOA</span>
            </button>
            <button class="btn quick-btn" type="button" [class.active]="categoryMode() === 'Banking'" (click)="setCategoryMode('Banking')">
              <lucide-icon [img]="RefreshCwIcon" [size]="15"></lucide-icon><span class="ms-2">BANKING LOA</span>
            </button>
          </div>
          <div class="toolbar-filters">
            <div class="search-field position-relative">
              <lucide-icon [img]="SearchIcon" [size]="16" class="search-icon"></lucide-icon>
              <input class="form-control search-input" placeholder="Search LOA or entity" [value]="draftSearch()" (input)="updateDraftSearch(searchInput.value)" #searchInput />
            </div>
            <div class="filter-field">
              <label class="form-label mb-1">Status</label>
              <select class="form-select form-select-sm" style="min-width:165px" [value]="draftStatusFilter()" (change)="updateDraftStatusFilter(statusFilter.value)" #statusFilter>
                <option value="all">All Status</option>
                <option value="approved">Approved</option>
                <option value="pending">Pending</option>
                <option value="rejected">Rejected</option>
                <option value="draft">Draft</option>
                <option value="deleted">Deleted</option>
              </select>
            </div>
            <div class="filter-field">
              <label class="form-label mb-1">From Date</label>
              <input class="form-control form-control-sm" style="min-width:165px" type="date" [value]="draftFromDate()" (input)="updateDraftFromDate(fromDateInput.value)" #fromDateInput />
            </div>
            <div class="filter-field">
              <label class="form-label mb-1">To Date</label>
              <input class="form-control form-control-sm" style="min-width:165px" type="date" [value]="draftToDate()" (input)="updateDraftToDate(toDateInput.value)" #toDateInput />
            </div>
            <button class="btn btn-primary btn-sm filter-action" type="button" (click)="applyFilters()">
              <lucide-icon [img]="ArrowRightIcon" [size]="15"></lucide-icon><span class="ms-2">GO</span>
            </button>
            <button class="btn btn-outline-secondary btn-sm filter-action" type="button" (click)="clearFilters()">
              <lucide-icon [img]="XIcon" [size]="15"></lucide-icon><span class="ms-2">CLEAR</span>
            </button>
            <button class="btn btn-sm create-btn export export-excel-btn" type="button" (click)="exportLoas()" aria-label="Export Excel" title="Export Excel">
              <lucide-icon [img]="FileDownIcon" [size]="16" class="excel-icon"></lucide-icon>
            </button>
          </div>
        </div>

        <div class="table-wrap mb-3">
          <div class="table-responsive" style="max-height: 500px; overflow-y: auto;">
            <table class="table table-sm mb-0 align-middle">
              <thead class="table-head sticky-top">
                <tr>
                  <th scope="col">S.No.</th>
                  <th scope="col">LOA Number</th>
                  <th scope="col">LOA Type</th>
                  <th scope="col">Entity</th>
                  <th scope="col">State</th>
                  <th scope="col">Period</th>
                  <th scope="col">Time</th>
                  <th scope="col">No. of Days</th>
                  <th scope="col">Total Quantum</th>
                  @if (showReturnQuantumColumn()) {
                    <th scope="col">Return Quantum (MWh)</th>
                  }
                  <th scope="col">Region</th>
                  <th scope="col">Approval Status</th>
                  <th scope="col">LOA Status</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                @if (loading()) {
                  <tr><td [attr.colspan]="showReturnQuantumColumn() ? 14 : 13" class="text-center text-muted py-5">Loading LOA Management</td></tr>
                } @else if (pagedLoas().length === 0) {
                  <tr><td [attr.colspan]="showReturnQuantumColumn() ? 14 : 13" class="text-center text-muted py-5">No Records Found</td></tr>
                }
                @for (loa of pagedLoas(); track loa.id; let i = $index) {
                  <tr>
                    <td>{{ (currentPage() - 1) * pageSize() + i + 1 }}</td>
                    <td class="fw-semibold">{{ loa.loa_number }}</td>
                    <td>
                      <span class="metric-pill loa-type" [class.buy]="loa.category === 'Buy'" [class.sell]="loa.category === 'Sell'" [class.banking]="loa.category === 'Banking'">
                        {{ loa.category || '-' }}
                      </span>
                    </td>
                    <td>
                      <button class="btn btn-link p-0 entity-link" type="button" (click)="openVendorDetails(loa.vendor_id)">
                        {{ vendorMap()[loa.vendor_id] || 'Unknown' }}
                      </button>
                    </td>
                    <td>{{ resolveState(loa) }}</td>
                    <td>{{ formatDate(periodStart(loa)) }} to {{ formatDate(periodEnd(loa)) }}</td>
                    <td>{{ timeRange(loa) }}</td>
                    <td>
                      <span class="metric-pill day-count">{{ periodDayCount(loa) }}</span>
                    </td>
                    <td>{{ totalQuantumMwh(loa) }}</td>
                    @if (showReturnQuantumColumn()) {
                      <td>{{ returnQuantumMwh(loa) }}</td>
                    }
                    <td>{{ resolveRegion(loa) }}</td>
                    <td>
                      <span class="status-pill text-uppercase" [class.pending]="loa.status === 'pending'" [class.draft]="loa.status === 'draft'" [class.rejected]="loa.status === 'rejected'">
                        <lucide-icon [img]="CircleCheckIcon" [size]="14"></lucide-icon>
                        {{ approvalStatusLabel(loa.status) }}
                      </span>
                    </td>
                    <td>
                      <span class="status-pill text-uppercase" [class.rejected]="loaLifecycleStatus(loa) === 'EXPIRED'">
                        <lucide-icon [img]="CircleCheckIcon" [size]="14"></lucide-icon>
                        {{ loaLifecycleStatus(loa) }}
                      </span>
                    </td>
                    <td>
                      @if (!isVendorUser()) {
                        <button class="action-edit me-1" type="button" [disabled]="!canEditLoa(loa)" (click)="router.navigateByUrl('/loas/' + loa.id + '/edit')">
                          <lucide-icon [img]="PencilIcon" [size]="14"></lucide-icon>
                        </button>
                        <button class="action-delete me-1" type="button" [disabled]="!canDeleteLoa(loa)" [title]="deleteTitle(loa)" (click)="removeLoa(loa)">
                          <lucide-icon [img]="Trash2Icon" [size]="14"></lucide-icon>
                        </button>
                      }
                      <button class="action-eye me-1" type="button" (click)="router.navigateByUrl('/loas/' + loa.id)">
                        <lucide-icon [img]="EyeIcon" [size]="14"></lucide-icon>
                      </button>
                     
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-center gap-2 flex-wrap">
          <div class="pager-meta">{{ startRow() }}-{{ endRow() }} of {{ filteredLoas().length }} LOAs</div>
          <div class="pagination-shell">
            <button class="pager-btn" type="button" [disabled]="currentPage() <= 1" (click)="goFirst()">
              <lucide-icon [img]="ChevronsLeftIcon" [size]="14"></lucide-icon>
            </button>
            <button class="pager-btn" type="button" [disabled]="currentPage() <= 1" (click)="currentPage.set(currentPage() - 1)">
              <lucide-icon [img]="ChevronLeftIcon" [size]="14"></lucide-icon>
            </button>
            <span class="page-indicator current">{{ currentPage() }}</span>
            <button class="pager-btn" type="button" [disabled]="currentPage() >= totalPages()" (click)="currentPage.set(currentPage() + 1)">
              <lucide-icon [img]="ChevronRightIcon" [size]="14"></lucide-icon>
            </button>
            <button class="pager-btn" type="button" [disabled]="currentPage() >= totalPages()" (click)="goLast()">
              <lucide-icon [img]="ChevronsRightIcon" [size]="14"></lucide-icon>
            </button>
            <select class="form-select form-select-sm page-size-select" [value]="pageSize()" (change)="setPageSize(pageSizeSelect.value)" #pageSizeSelect>
              @for (size of pageSizes; track size) {
                <option [value]="size">{{ size }}/Page</option>
              }
            </select>
          </div>
        </div>
      </div>
    </div>
  
